import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";

const productsAtom = atom([]);

const useProducts = () => {
  const [products, setProducts] = useAtom(productsAtom);

  const onGetProducts = () => {
    dataService.get(`constants/produits`, (data) => {
      setProducts(
        (data || []).map(({ id, nom, typeContratId }) => ({
          id,
          name: nom,
          productType: typeContratId,
        })),
      );
    });
  };

  return {
    products,
    onGetProducts,
  };
};

export default useProducts;
